<div class="px-[25px] py-[25px] !bg-[#F0F0F0]">
  <label class="!text-[20px] font-semibold Roboto !pb-[25px]">New RFI</label>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="!mt-[25px]">
    <div class="py-[8px] px-[45px] !bg-[#FFFFFF]">
    <label class="!text-[20px] font-semibold Roboto">REQUEST</label>

      <div class="relative w-[26.8125rem] !mt-[10px]">
        <!-- Material Form Field -->
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Subject</mat-label>
          <input
            matInput
            type="text"
            placeholder="Subject"
            formControlName="subject"
            class="bg-[#F1F3F5] text-[#21252A] pl-2 w-full border-none"
          />
          <mat-error *ngIf="form.get('subject')?.hasError('required')">
            Subject is required
          </mat-error>
        </mat-form-field>
      </div>
      <label>Question <span class="!text-red-700">*</span></label>
      <div class="flex grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
  
        <div class="w-[100%]">
          <app-rich-textEditor
            class="w-[100%]"
            required="true"
            [richTextValue]="form.get('question')?.value"
          ></app-rich-textEditor>
        </div>
      
        <div class="w-[80%] mt-[35px]">
          <div class="bg-[#FFFFFF]">
            <div
              class="flex h-[170px] flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 bg-[#F7F6FB] hover:bg-gray-100"
            >
              <button
                type="button"
                class="bg-[#D9D9D9] text-[#343A40] px-4 py-2 rounded hover:bg-[#F1F3F5] focus:outline-none"
                (click)="fileControlRef.click()"
              >
                Attach File
              </button>
              <p class="text-[14px] pt-[5px] !font-medium !m-0 !text-[#21252A]">
                Drag & Drop
              </p>
      
              <input
                type="file"
                multiple
                #fileControlRef
                (change)="onFileUpload($event)"
                hidden
              />
            </div>
      
            <!-- Uploaded Files Section -->
            <div *ngIf="uploadedFiles.length > 0" class="mt-4">
              <ul class="list-disc pl-5">
                <li *ngFor="let file of uploadedFiles">{{ file.name }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div>
        <h4 class="!text-[18px] font-semibold mb-4">GENERAL INFORMATION</h4>
        <!-- First Row -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[1rem]">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Number</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="number"
                  formControlName="number"
                  class="bg-[#F1F3F5] text-[#21252A] pl-2 w-full border-none"
                />
              </mat-form-field>
              <mat-form-field class="!w-[100%]" appearance="outline">
                <mat-label> Due Date </mat-label>
                <input
                  matInput
                  type="text"
                  [matDatepicker]="due_date"
                  formControlName="due_date" 
                  placeholder="Due Date"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="due_date"
                ></mat-datepicker-toggle>
                <mat-datepicker #due_date startView="year"></mat-datepicker>
                <mat-error *ngIf="form.get('due_date')?.hasError('required')">
                    Subject is required
                  </mat-error>
              </mat-form-field>
             
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>RFI Manager</mat-label>
                <mat-select 
                  formControlName="rfi_management" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="RFI Manager*">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('rfi_management')?.hasError('required')">
                  RFI Manager is required
                </mat-error>
              </mat-form-field>
              
        </div>
        <!-- Second Row -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[1rem]">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Received Form</mat-label>
                <mat-select 
                  formControlName="received_form" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Received Form">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('received_form')?.hasError('required')">
                    Received Form is required
                  </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Assignee</mat-label>
                <mat-select 
                  formControlName="assignee" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Assignee"
                  multiple="true">
                  
                  <mat-select-trigger class="flex flex-wrap">
                    <mat-chip  class="custom-chip !text-white" *ngFor="let assignee of form.get('assignee').value; let i = index" [removable]="true"
                    (removed)="removeItem('assignee',i)"
                    >
                      {{ assignee }}
                      <mat-icon matChipRemove class="!text-white">close</mat-icon>
                  </mat-chip>
                  </mat-select-trigger>
                    
              
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('assignee')?.hasError('required')">
                    Assignee is required
                  </mat-error>
              </mat-form-field>
             
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Distributed List</mat-label>
                <mat-select 
                  formControlName="distributed_list" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  multiple="true"
                  placeholder="Distributed List">
                  <mat-select-trigger class="flex flex-wrap">
                    <mat-chip  class="custom-chip !text-white" *ngFor="let distributed_list of form.get('distributed_list').value; let i = index" [removable]="true"
                    (removed)="removeItem('distributed_list',i)"
                    >
                      {{ distributed_list }}
                      <mat-icon matChipRemove class="!text-white">close</mat-icon>
                  </mat-chip>
                  </mat-select-trigger>
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('distributed_list')?.hasError('required')">
                    Distributed List is required
                  </mat-error>
              </mat-form-field>
              
        </div>
        <!-- Third Row -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[1rem]">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Responsible Contractor</mat-label>
                <mat-select 
                  formControlName="responsible_contractor" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Responsible Contractor">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('responsible_contractor')?.hasError('required')">
                    Responsible Contractor is required
                  </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Spec Section</mat-label>
                <mat-select 
                  formControlName="spec_section" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Spec Section">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('spec_section')?.hasError('required')">
                    Spec section is required
                  </mat-error>
              </mat-form-field>
             
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Location</mat-label>
                <mat-select 
                  formControlName="location" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Location">
                  <mat-option value="pakistan">
                   pakistan
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('location')?.hasError('required')">
                    Location is required
                  </mat-error>
              </mat-form-field>
              
        </div>
         <!-- Forth Row -->
         <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[1rem]">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>RFI Stage</mat-label>
                <mat-select 
                  formControlName="rfi_stage" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="RFI Stage">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('rfi_stage')?.hasError('required')">
                    RFI Stage is required
                  </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Drawing Number</mat-label>
                <mat-select 
                  formControlName="drawing_number" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Drawing Number">
                  <mat-option *ngFor="let number of d_number" [value]="number">
                    {{ number }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('drawing_number')?.hasError('required')">
                    Drawing Number is required
                  </mat-error>
              </mat-form-field>
             
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Cost Code</mat-label>
                <mat-select 
                  formControlName="cost_code" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Cost Code">
                  <mat-option *ngFor="let code of code_cost" [value]="code">
                    {{ code }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('cost_code')?.hasError('required')">
                    Cost Code is required
                  </mat-error>
              </mat-form-field>
              
        </div>
          <!-- fifth Row -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-[1rem]">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>Schedule Impact</mat-label>
                <mat-select 
                  formControlName="schedule_impact" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Schedule Impact">
                  <mat-option *ngFor="let rfi of rfi_management" [value]="rfi">
                    {{ rfi }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('schedule_impact')?.hasError('required')">
                    Schedule Impact is required
                  </mat-error>
              </mat-form-field>

              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Cost Impact</mat-label>
                <mat-select 
                  formControlName="cost_impact" 
                  class=" text-[#21252A] pl-2 w-full border-none"
                  placeholder="Cost Impact">
                  <mat-option *ngFor="let number of d_number" [value]="number">
                    {{ number }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('cost_impact')?.hasError('required')">
                    Cost Impact is required
                  </mat-error>
              </mat-form-field>
             
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>Reference</mat-label>
                <input
                matInput
                type="text"
                placeholder="Reference"
                formControlName="reference"
                class="bg-[#F1F3F5] text-[#21252A] pl-2 w-full border-none"
              />
              </mat-form-field>
              
        </div>
      </div>

      <div>
        <div class="mb-4">
            <label class="block text-gray-800 font-semibold mb-2">Status</label>
        </div>
        <div class="mb-4">
            <label class="block text-gray-800 font-semibold mb-2">Created By</label>
        </div>
        <div class="mb-4">
            <label class="block text-gray-800 font-semibold mb-2">Date Initiated</label>
        </div>
        <div class="flex items-center">
            <label class="block text-gray-800 font-semibold mr-2">Private</label>
            <input type="checkbox" class="form-checkbox h-4 w-4 text-gray-800">
        </div>
      </div>
      <!-- <button mat-button type="submit" [disabled]="form.invalid">Submit</button> -->
    </div>
    <!-- Back and next Buttons -->
  <div
  class="relative bottom-0 right-0 !pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button type="button" class="back-btn !shadow-none" (click)="close()">
      Cancel
    </button>
    <button type="button" class="back-btn">
      Create as Draft
    </button>
    <button
    (click)="navigateTo()"
      class="!h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] px-[15px]"
      style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      
    >
    Create as Open
    </button>
  </div>
</div>
  </form>
</div>
